module.exports = __webpack_public_path__ + "static/media/hdir-logo-hvit-eng.4a773ca4.svg";